import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_EMAILS } from '../data/contact';

export default function Footer() {
  const socialLinks = [
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/tissatech',
      icon: 'https://img.icons8.com/color/48/linkedin.png',
    },
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/tissatech/',
      icon: 'https://img.icons8.com/color/48/facebook-new.png',
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/tissadigital/',
      icon: 'https://img.icons8.com/fluency/48/instagram-new.png',
    },
    {
      name: 'YouTube',
      href: 'https://www.youtube.com/@tissatechnology3196',
      icon: 'https://img.icons8.com/color/48/youtube-play.png',
    },
  ];

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div>
          <p style={{ marginTop: 0, fontSize: 14, lineHeight: 1.7 }}>
            TISSA Technology helps enterprises modernize integration, ERP, data and
            cloud platforms with SAP BTP, API-led architecture and AI-driven solutions.
          </p>
          <div className="footer-social" aria-label="Social media links">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                className="footer-social-link"
                href={social.href}
                target="_blank"
                rel="noreferrer"
                aria-label={social.name}
                title={social.name}
              >
                <img
                  className="footer-social-icon"
                  src={social.icon}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </div>
        <div className="footer-nav">
          <h4>Services</h4>
          <Link to="/services">SAP BTP</Link>
          <Link to="/services">Integration Modernization</Link>
          <Link to="/services">Data &amp; Analytics</Link>
          <Link to="/services">ERP &amp; CRM</Link>
          <Link to="/services">AI Services</Link>
        </div>
        <div className="footer-nav">
          <h4>Company</h4>
          <Link to="/solutions">Solutions</Link>
          <Link to="/case-studies">Case Studies</Link>
          {/* <Link to="/insights">Insights</Link> */}
          <Link to="/careers">Careers</Link>
        </div>
        <div className="footer-nav">
          <h4>Contact</h4>
          <a href={`mailto:${CONTACT_EMAILS.general}`}>{CONTACT_EMAILS.general}</a>
          <a href="https://tissatech.com" target="_blank" rel="noreferrer">tissatech.com</a>
          <a href="https://tissatech.com/keystatic">Editor Login</a>
          <p style={{ margin: '8px 0', fontSize: 14 }}>USA + India Delivery</p>
        </div>
      </div>
      <div className="container footer-bottom">
        © 2026 TISSA Technology LLC. All rights reserved.
      </div>
    </footer>
  );
}
